<!--
     <FieldString>
-->

<template>
  <span
    v-if="('' + field).length <= max_text_size || is_mobile"
    :class="css_class"
  >
    {{ representation }}
  </span>
  <v-tooltip bottom v-else>
    <template v-slot:activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
        style="cursor:default;"
        :class="css_class"
      >
        {{ representation }}
      </span>
    </template>
    <span :class="css_class">{{ field }}</span>
  </v-tooltip>
</template>

<style lang="scss">
.string-field-content {
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
}
</style>

<script>
  export default {
    name: 'FieldString',

    props: {
      field: { required: true },
      short: { type: Boolean, default: false },
      is_mobile: { type: Boolean, default: false },
      max_text_size: { type: Number, default: 50 },
      css_class: {type: String, default:"string-field-content"}
    },

    computed: {
      representation() {
        const value = '' + this.field;
        if (this.short) {
          return value.length > this.max_text_size
            ? value.substring(0, this.max_text_size) + '...'
            : value;
        } else {
          return value;
        }
      },
    },
  }
</script>